import { memo } from 'react';

import styles from './index.less';

interface IProps {
  content: string;
  avatar?: string;
}

const defaultBotAvatar =
  'https://mindverseglobal.mindverse.com/front-img/crm/1737439207363/mebot-bio.png';

function AIMessage({ content, avatar }: IProps) {
  if (!content) {
    return null;
  }

  return (
    <div className={styles.messageRowRight}>
      <div className={styles.messageContentRight}>
        <div className={styles.messageBubbleAI}>
          <pre className={styles.messageText}>{content}</pre>
        </div>
      </div>
      <div className={styles.avatarWrapper}>
        <img alt="ai" className={styles.avatar} src={avatar || defaultBotAvatar} />
        <img
          alt=""
          className={styles.avatarFrame}
          src="https://mindverseglobal.mindverse.com/front-img/crm/1769162061121/AIAvatar.png"
        />
      </div>
    </div>
  );
}

export default memo(AIMessage);
